import React from "react";
import { BadgeCheck, Percent, Info, Star } from "lucide-react";

const discountPerks = [

  { text: "15% Discount on In-Cinema Food & Beverage", value: 15 },
  
];

const disclaimers = [
  "The card does not entitle benefits in banquet & conference bookings, special events, or promotions.",
  "Blackout dates may apply.",
  "The card is non-transferable. If lost or stolen, please contact us immediately.",
];

const MembershipPerksCard = () => {
  return (
    <section className="bg-gradient-to-br from-red-950 to-red-900 py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-r from-red-900 to-red-950 shadow-2xl rounded-2xl p-8 border border-red-700">
          {/* Decorative elements */}
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-12 h-12 border-t-2 border-l-2 border-white rounded-tl-lg"></div>
            <div className="absolute -top-6 -right-6 w-12 h-12 border-t-2 border-r-2 border-white rounded-tr-lg"></div>
            <div className="absolute -bottom-6 -left-6 w-12 h-12 border-b-2 border-l-2 border-white rounded-bl-lg"></div>
            <div className="absolute -bottom-6 -right-6 w-12 h-12 border-b-2 border-r-2 border-white rounded-br-lg"></div>
          </div>

          <div className="text-center mb-8 relative">
            <div className="flex justify-center mb-3">
              <Star className="w-5 h-5 text-white" fill="#FFFFFF" />
              <div className="mx-2 h-px w-24 bg-gradient-to-r from-transparent via-white to-transparent self-center"></div>
              <Star className="w-5 h-5 text-white" fill="#FFFFFF" />
            </div>
            <h2 className="text-3xl font-bold text-white">
              Grand <span className="text-blue-300">Cinemaz</span> Membership
            </h2>
            <p className="text-gray-200 mt-2 italic">
              Exclusive privileges for our distinguished guests
            </p>
            <div className="flex justify-center mt-3">
              <Star className="w-5 h-5 text-white" fill="#FFFFFF" />
              <div className="mx-2 h-px w-24 bg-gradient-to-r from-transparent via-white to-transparent self-center"></div>
              <Star className="w-5 h-5 text-white" fill="#FFFFFF" />
            </div>
          </div>

          <div className="bg-red-950 bg-opacity-70 rounded-xl p-6 backdrop-blur-sm mb-8 border border-red-800">
            <ul className="grid gap-4">
              {discountPerks.map((perk, index) => (
                <li
                  key={index}
                  className="flex items-start text-white group hover:text-blue-300 transition-colors duration-300"
                >
                  <div className="flex justify-center items-center w-8 h-8 rounded-full border border-white bg-red-900 mr-3">
                    <Percent className="text-white w-4 h-4 group-hover:scale-110 transition-transform duration-300" />
                  </div>
                  <span className="self-center">{perk.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-center relative mt-12">
            {/* Top Line */}
            <div className="h-px w-full bg-gradient-to-r from-transparent via-white to-transparent mb-6"></div>

            {/* Highlighted Offer */}
            <div className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-amber-600 to-amber-500 text-white font-semibold rounded-lg shadow-lg border border-amber-700 hover:scale-105 transition-transform duration-300">
              <BadgeCheck className="w-5 h-5 mr-2" />
              Get FREE Membership after 10 Ticket Bookings!
            </div>

            {/* Bottom Line */}
            <div className="h-px w-full bg-gradient-to-r from-transparent via-white to-transparent mt-6"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipPerksCard;
